import cx from 'clsx';
import React, {useContext, useEffect} from 'react';
import styles from './EmbedForm.module.scss';
import { LanguageContext } from 'context';

interface OwnProps {
  name: string;
  formId?: string;
  theme?: 'dark' | 'white';
  message?: string;
  embed?: string;
  small?: boolean;
}

const EmbedForm: React.FC<OwnProps & JSX.IntrinsicElements['div']> = (props) => {
  const { formId, className, theme = 'dark', message, embed, small = false, ...rest } = props;
  const { language } = useContext(LanguageContext);

  const wrapperClassNames = cx({
    [styles.wrapper]: true,
    [styles.dark]: theme === 'dark',
    [styles.white]: theme === 'white',
    [styles.small]: small,
    ...(className && { [className]: true }),
  });

  useEffect(() => {
    const applyStyleToGetResponseForm = () => {
      const getResponseForm = document.querySelector('getresponse-form')?.shadowRoot;
      if (getResponseForm) {
        const style = document.createElement('style');
        style.textContent = `select option { color: black !important; }`;
        getResponseForm.appendChild(style);
      }
    };

    applyStyleToGetResponseForm();
  }, [language]);

  return (
      <div className={wrapperClassNames} {...rest}>
        <div className="_form_ formVisible">
          {language === 'en' &&
              <getresponse-form form-id="19ebe94e-e044-408c-bc84-c4cd4411e8cb" e="0"></getresponse-form>
          }
          {language === 'de' &&
              <getresponse-form form-id="2fd4c3cb-5302-47c8-b803-02b59d9d2bf6" e="0"></getresponse-form>
          }
          {language === 'pl' &&
              <getresponse-form form-id="38408020-05d0-4160-9893-dc5bca2331b2" e="0"></getresponse-form>
          }
        </div>
      </div>
  );
};

export default EmbedForm;
